import {json} from '../../../core/data-source/json.mapper';

export class VehicleChecksFaultsFormSubmissioRecord {
    @json()
    comment: string;

    @json()
    photos: string[];
}
